/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotIframe = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'IFRAME',
]);

export default [
  ...[
    getFilterWithCol(['FieldText', {
      name: 'iframe_src',
      label: null,
      prefix: 'Url:',
    }], 24),
    getFilterWithCol(['FieldText', {
      name: 'iframe_width',
      label: null,
      prefix: 'Width:',
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'iframe_height',
      label: null,
      prefix: 'Height:',
    }], 12),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotIframe, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
